<script lang="ts">
  import { push } from 'svelte-spa-router';
  import Table from '../../Table.svelte';
  import type { RecentUnconfirmedBankDetails } from '../../../lib/api/admin/dashboard.service';
  import { formatDate } from '../../../lib/utils/formatters';

  export let charities: RecentUnconfirmedBankDetails[] = [];
  export let loading = false;
  export let error: string | null = null;

  const columns = [
    {
      key: 'charity_name',
      label: 'Charity',
      width: '60%',
      mobilePrimary: true,
      render: (value: string) => `<span class="charity-name">${value}</span>`
    },
    {
      key: 'updated_at',
      label: 'Last updated',
      width: '40%',
      render: (value: string | null) =>
        `<span class="date-value">${value ? formatDate(value) : '—'}</span>`
    }
  ];

  function handleRowClick(row: RecentUnconfirmedBankDetails) {
    if (row?.charity_uuid) {
      push(
        `/charity-profile/${row.charity_uuid}?return=${encodeURIComponent('/admin/unconfirmed-bank-details')}`
      );
    }
  }
</script>

{#if loading}
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading unconfirmed bank details...</p>
  </div>
{:else if error}
  <div class="error-container">
    <p class="error-message">{error}</p>
  </div>
{:else}
  <Table
    actionText="View All"
    actionHref="#/admin/unconfirmed-bank-details"
    {columns}
    data={charities}
    onRowClick={handleRowClick}
  />
{/if}

<style>
  .loading-container,
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    text-align: center;
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    padding: 2rem;
  }

  .loading-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e5e7eb;
    border-left-color: var(--color-primary, #ffb400);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 0.75rem;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .error-message {
    color: #ef4444;
    margin: 0;
  }
</style>
